module.exports = __webpack_public_path__ + "media/app/fonts/catamaran-v4-latin-700-afad9c85f49975a6f941a4feec6874d0.eot";